<template>
    <div class="detailBanner">
        <img v-bind:src="bannerObj.imgUrl" >
        <span>{{bannerObj.text}}</span>
    </div>
</template>

<style lang="scss">
    .detailBanner {
        width: 100%;
        position: relative;
        img {
            display: block;
            width: 100%;
            height: auto;
        }
        span {
            display: block;
            font-size: 60px;
            font-family: 'Arial Black';
            color: #fff;
            text-align: center;
            position: absolute;
            bottom: -8px;
            right: 0;
            left: 0;
            margin: auto;
            z-index: 5;
        }
    }
</style>

<script>
    import store from '../vuex'
    export default {
        name: "DetailBanner",
        props: ['bannerObj'],
        store
    }
</script>


